import React from 'react';

interface BadgeProductSaleProps {
    outline?: boolean;
    className?: string;
}

const BadgeProductSale = ({
    outline = false,
    className
}: BadgeProductSaleProps) => {

    return (
        <div className={`
            ${outline ? 'ring-1 ring-shopfood-success text-shopfood-success' : 'bg-shopfood-success text-white'}
            font-bold px-1.5 py-0.5 text-xs ${className}`
            }>
            Promoção
        </div>
    );
};

export default BadgeProductSale;
